import { platform } from 'playcanvas';
import { DEFAULT_AVATAR_MAPPING } from '../../submodules/supersplat-viewer/src/avatar/AvatarTypes';
import type { Annotation as SettingsAnnotation } from '../../submodules/supersplat-viewer/src/settings';
import type { State } from '../../submodules/supersplat-viewer/src/types';
import type { ViewerAnnotation, ViewerInitOptions } from '@mindcloudxai/shared';

export function createInitialState(options: ViewerInitOptions = {}): State {
  return {
    loaded: false,
    readyToRender: false,
    performanceMode: platform.mobile,
    progress: 0,
    inputMode: platform.mobile ? 'touch' : 'desktop',
    cameraMode: 'orbit',
    hasAnimation: false,
    animationDuration: 0,
    animationTime: 0,
    animationPaused: true,
    hasAR: false,
    hasVR: false,
    hasCollision: false,
    hasCollisionOverlay: false,
    walkAllowed: false,
    collisionOverlayEnabled: false,
    isFullscreen: false,
    controlsHidden: false,
    gamingControls: false,
    avatarEnabled: options.avatarEnabled ?? !!options.avatarUrl,
    avatarAvailable: false,
    avatarLoading: false,
    avatarUrl: options.avatarUrl ?? '',
    avatarStatus: '',
    avatarAnimations: [],
    avatarCurrentAnimation: '',
    avatarFollowCamera: options.avatarFollowCamera ?? true,
    avatarMapping: { ...DEFAULT_AVATAR_MAPPING, ...options.avatarMapping },
  };
}

export function fromSettingsAnnotation(ann: SettingsAnnotation): ViewerAnnotation {
  return {
    position: { x: ann.position[0], y: ann.position[1], z: ann.position[2] },
    title: ann.title,
    text: ann.text || undefined,
    camera: ann.camera?.initial
      ? {
          position: {
            x: ann.camera.initial.position[0],
            y: ann.camera.initial.position[1],
            z: ann.camera.initial.position[2],
          },
          target: {
            x: ann.camera.initial.target[0],
            y: ann.camera.initial.target[1],
            z: ann.camera.initial.target[2],
          },
          fov: ann.camera.initial.fov,
        }
      : undefined,
  };
}
